
import apis from '@/const/apis';
import requestQueueGet from '@/utils/request/queueGet';
import store from '@/store'
import { Vue, Component } from 'vue-property-decorator'
import { Action, Getter, State } from 'vuex-class'
import layout from './layout.vue'
import ModuleItem from './module-item.vue'
import {
  updateFirstAccountInfo,
  updateInvoiceInfo,
  updateAccountInfo,
  updateGuideStatus,
} from '@/service'
import { BusinessTaxType, FIELD } from '@/const/qualification'
import draftMixin from '@/mixins/draftMixin'
import {
  DimensionType,
  StatusNotificationReq,
  GuideStatus,
} from '@/const/notification'
import { trackEvent } from '@/tea-tracker'

@Component({
  name: 'Qualification',
  components: {
    layout,
    ModuleItem,
  },
  filters: {},
  mixins: [draftMixin],
})
export default class Qualification extends Vue {
  @State(state => state?.account?.accountInfo) accountInfo: any
  @Getter('account/singleAccount') singleAccount: boolean
  @Getter('account/adverId') adverId: string
  @Getter('account/multipleAccount') multipleAccount: boolean
  @Getter('qualification/showBusinessInfoModule')
  showBusinessInfoModule: boolean
  @Getter('qualification/businessInfoItemsVisible') businessInfoItemsVisible: {
    company: boolean;
    contacter: boolean;
    telephone: boolean;
    contacter_email: boolean;
  }
  @State('qualConfig', { namespace: 'qualification' }) qualConfig: any
  @State('formModule', { namespace: 'qualification' }) formModule: any
  @State('formData', { namespace: 'qualification' }) formData: any
  @State('pageTextInfo', { namespace: 'qualification' }) pageTextInfo: any
  @State('hasPostposition', { namespace: 'qualification' })
  hasPostposition: boolean
  @Getter('account/isSelfAccount') isSelfAccount: boolean
  @Getter('account/isNotBcChildSelfAccount') isNotBcChildSelfAccount: boolean
  @Action('qualification/initData') initData: Function
  @Action('qualification/updateFormData') updateFormData: Function
  @Action('qualification/checkFormContentPostPosition')
  checkFormContentPostPosition: Function
  @Action('account/loadAccountInfo') loadAccountInfo: Function
  @Action('notification/updateGuideStatus') updateGuideStatus: (
    param: StatusNotificationReq
  ) => Promise<void>
  @Action('fastCreation/hasValidPayment') hasValidPayment: Function

  /**
   * 需要disable提交按钮，否则用户点击操作频繁会触发多次资质提交
   * 资质+创编接口提交成功，loading隐藏会出现toast提示用户提交成功，这个时间窗口里用户再持续点击submit就会触发接口请求了
   */
  // 整体 submit 按钮的 loading 状态
  publishing = false
  ifValid = false
  formIndex = 0 // 0-前置表单， 1-后置表单
  $globalLoading: any

  get currentOrder() {
    return !!this.formIndex ? 2 : 1
  }
  get getPreview() {
    return !!this.formIndex
      ? 'simplified_billinginfoback_pageview2'
      : 'simplified_billinginfoback_pageview1'
  }
  get filterModule() {
    return this.formModule?.filter(i => !i.children.every(c => c.hidden))
  }
  get getSpread() {
    let list = this.formModule?.filter(i =>
      i.field === 'billing_address' ? true : !i.children.every(c => c.hidden),
    )
    if (this.showBusinessInfoModule) {
      list += 1
    }

    return list.length === 1
  }

  get nextBtnText(): string {
    if (!this.ifValid && this.isNotBcChildSelfAccount) {
      return this.$t('common_next')
    }
    return this.$t('common_confirm')
  }
  // business info start
  get businessInfoModuleData() {
    const { extraTips } = this.qualConfig?.fieldText || {}
    return {
      field: 'business_info',
      type: 'module',
      component: 'input',
      label: this.$t('self_ac_business_information'),
      placeholder: this.$t('self_ac_business_information'),
      validators: [],
      children: [
        {
          field: 'company',
          name: 'company',
          type: 'cell',
          component: 'input',
          label: this.$t('self_ac_company'),
          placeholder: this.$t('common_input_placeholder'),
          extraTips: extraTips?.company || '',
          validators: [
            {
              required: true,
              message: this.$t('common_input_require_required'),
            },
            {
              // 过滤表情包
              realPattern:
                /^(?!.*(\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]))/i,
              message: this.$t('common_input_require_number_or_char'),
            },
          ],
          hidden: !this.businessInfoItemsVisible.company,
        },
        {
          field: 'contacter',
          name: 'contacter',
          type: 'cell',
          component: 'input',
          label: this.$t('self_ac_contactor_name'),
          placeholder: this.$t('common_input_placeholder'),
          validators: [
            {
              required: true,
              message: this.$t('common_input_require_required'),
            },
            {
              // 过滤表情包
              realPattern:
                /^(?!.*(\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]))/i,
              message: this.$t('common_input_require_number_or_char'),
            },
          ],
          hidden: !this.businessInfoItemsVisible.contacter,
        },
        {
          field: 'telephone',
          name: 'telephone',
          type: 'block',
          component: 'phone-input',
          label: this.$t('self_register_phonenumber'),
          hidden: !this.businessInfoItemsVisible.telephone,
        },
        {
          field: 'contacter_email',
          name: 'contacter_email',
          type: 'cell',
          component: 'input',
          label: this.$t('self_ac_contactor_email'),
          placeholder: this.$t('common_input_placeholder'),
          validators: [
            {
              required: true,
              message: this.$t('common_input_require_required'),
            },
            {
              realPattern:
                /^[a-z0-9]+([._\-+]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]*\.){1,63}[a-z0-9]+$/i,
              message: this.$t('account_check_email_hint'),
            },
          ],
          hidden: !this.businessInfoItemsVisible.contacter_email,
        },
      ],
    }
  }
  // business info end

  beforeRouteEnter(to: any, from: any, next: any): void {
    store.commit('qualification/RESET_STATE')
    if (to.query?.from === 'budget') {
      next()
      return
    }
    store
      .dispatch('qualification/initQualificationForm', {
        formIndex: to.query?.formIndex,
      })
      .then((needGotoQualification: boolean) => {
        if (needGotoQualification) {
          next()
        } else {
          next({ name: 'objective' })
        }
      })
      .catch(() => {
        if (from.name === 'budget') {
          next()
          return
        }
        next({ name: 'objective' })
      })
  }

  isLink(data) {
    if (data.children.length > 1) {
      return true
    } else {
      const child = data.children[0]
      return child.component !== 'input' && child.type === 'cell'
    }
  }
  getConfig(data) {
    return data.children.length > 1 ? data : data.children[0]
  }
  beforeCreate() {
    this.$globalLoading.show()
  }

  async setContactInfo(): Promise<any> {
    return await requestQueueGet(apis.account.contact, {
      aadvid: this.adverId,
    });
  }

  async setTaxVerificationStatus(): Promise<any> {
    return await requestQueueGet(apis.account.taxVerificationStatus, {
      aadvid: this.adverId,
    });
  }

  async mounted(): Promise<void> {
    try {
      this.formIndex = !!Number(this.$route.query?.formIndex)
        ? Number(this.$route.query?.formIndex)
        : this.formIndex;
      await this.initData({ formIndex: this.formIndex }).finally(() => {
        this.$globalLoading.hide();
      });
      const res = await Promise.all([this.setContactInfo(), this.hasValidPayment(), this.setTaxVerificationStatus()]);
      const [{ data: contactInfo }, paymentReady, { data: taxInfo }] = res;
      this.ifValid = paymentReady;
      const updatedAccountInfo = {
        ...this.accountInfo,
        email: contactInfo?.contact_info?.email ?? this.accountInfo.email,
        telephone: contactInfo?.contact_info?.telephone ?? this.accountInfo.telephone,
        contacter: contactInfo?.contact_info?.contacter ?? this.accountInfo.contacter,
        contacter_email: contactInfo?.contact_info?.contacter_email ?? this.accountInfo.contacter_email,
        reject_reason: taxInfo?.reject_reason ?? this.accountInfo.reject_reason,
        tax_value: taxInfo?.tax_value ?? this.accountInfo.tax_value,
      };
      store.commit('account/SET_ACCOUNT_INFO', updatedAccountInfo);
    } catch (e) {
      console.log(e);
    }
  }

  async handleConfirm() {
    if (this.publishing) {
      true
    }
    trackEvent('adp_waplite_click', {
      order: this.currentOrder,
      billinginfo: !!this.formIndex
        ? 'simplified_billinginfoback_confirm2'
        : 'simplified_billinginfoback_confirm1',
    })
    this.publishing = true
    const validate = await this.validator()
    if (!validate) {
      this.publishing = false
      return
    }
    // 提交接口
    this.handleSubmit()
  }
  handleBack() {
    trackEvent('adp_waplite_click', {
      order: this.currentOrder,
      billinginfo: !!this.formIndex
        ? 'simplified_billinginfoback_back2'
        : 'simplified_billinginfoback_back1',
    })
    if (this.formIndex) {
      this.$router.go(-1)
    } else {
      this.$router.push({ name: 'budget' })
    }
    // 离开页面以后reset下上次填的内容
    setTimeout(() => this.updateFormData())
  }
  async validator() {
    const { businessInfoModuleItemRef, moduleItemRef } = this.$refs
    let moduleItemValidators = moduleItemRef?.map(item => item.validator())
    let validateResultArr = await Promise.all([
      businessInfoModuleItemRef ? businessInfoModuleItemRef.validator() : true,
      ...(moduleItemValidators ? moduleItemValidators : [true]),
    ])
    return validateResultArr.every(item => Boolean(item))
  }
  handleSubmit() {
    if (!this.formIndex) {
      const submitData = { ...this.formData }

      const { phonenumber, phonenumber_country } = this.formData.telephone || {}
      if (phonenumber) {
        submitData.telephone = phonenumber
        submitData.contacter_telephone_country = phonenumber_country
      }

      // 空值不上传
      [
        'company',
        'contacter',
        'telephone',
        'contacter_telephone_country',
        'contacter_email',
      ].forEach(key => {
        if (!submitData[key]) {
          delete submitData[key]
        }
      })

      // 首次提交的场景
      updateFirstAccountInfo(submitData)
        .then(async () => {
          // 首次提交之后 check 是不是已经没有后置的内容，是的话需要更新
          this.firstSubmitSuccess()
        })
        .catch(err => {
          // 已经提交过资质，以成功作为兜底
          if (err?.code === 1001) {
            this.firstSubmitSuccess()
          } else {
            this.submitError(err)
          }
        })
    } else {
      let submitData: any = {}
      this.formModule.map(m => {
        const value =
          m?.field === FIELD.TAX_VALUE
            ? this.formData?.tax_value
            : this.formData[m?.name]
        if (value && value !== -1 && JSON.stringify(value) !== '{}') {
          if (m?.field === FIELD.TAX_VALUE) {
            submitData.tax_value = value
          } else {
            submitData[m?.name] = value
          }
        }

        m.children?.map(c => {
          const val =
            c?.field === FIELD.TAX_VALUE
              ? this.formData?.tax_value
              : this.formData[c?.name]
          if (val && val !== -1 && JSON.stringify(val) !== '{}') {
            if (c?.field === FIELD.TAX_VALUE) {
              submitData.tax_value = val
            } else {
              submitData[c?.name] = val
            }
          }
        })
      })
      if (
        submitData.tax_value &&
        JSON.stringify(submitData.tax_value) !== '{}' &&
        !submitData?.tax_type
      ) {
        submitData.tax_type = this.formData?.tax_type || BusinessTaxType
      }
      this.handleUpdateAccountInfo(submitData)
    }
  }
  handleUpdateAccountInfo(submitData) {
    updateAccountInfo(submitData)
      .then(async () => {
        await this.getRealTimeAccountStatus()
        // 更新invoice 信息
        const tax_value = submitData?.tax_value
        if (Object.keys(tax_value || {}).length) {
          let resultTaxStr = ''
          const taxValues = Object.values(tax_value || {})
          if (taxValues.length === 1) {
            resultTaxStr = taxValues[0]
          } else if (taxValues.length > 1) {
            // 有两个或者以上税号的，取主税号
            if (tax_value?.vat !== undefined) {
              resultTaxStr = tax_value?.vat
            } else {
              resultTaxStr = taxValues[0]
            }
          }
          submitData.tax_value = resultTaxStr
        } else {
          delete submitData.tax_value
        }
        delete submitData.tax_type
        updateInvoiceInfo(submitData)
          .then(async () => {
            await this.updateGuideStatus({
              keys: [GuideStatus.POST_INVOICE_CONFIRM],
              dimension: DimensionType.adv,
            })
            this.$router.replace({ path: '/dashboard/index' })
          })
          .catch((err: any) => {
            this.trackError(err)
          })
          .finally(() => {
            this.publishing = false
          })
      })
      .catch(err => {
        this.submitError(err)
      })
  }
  submitError(err) {
    const errMsg = (err && err.msg) || this.$t('common_retry')
    this.$toast({
      message: errMsg,
    })
    this.publishing = false
    this.trackError(err)
  }
  trackError(err) {
    trackEvent('adp_waplite_impression', {
      simplified_billinginfoback_error: {
        order: this.currentOrder,
        code: err?.code,
        msg: err?.msg,
      },
    })
  }
  async firstSubmitSuccess() {
    await this.getRealTimeAccountStatus()
    console.log('1000')
    if (!this.hasPostposition) {
      this.updateAllForm()
    } else {
      const result = await this.checkFormContentPostPosition()
      if (result) {
        this.updateAllForm()
      } else {
        this.skipPage()
      }
    }
  }
  async updateAllForm() {
    await updateGuideStatus({
      keys: [GuideStatus.POST_INVOICE_CONFIRM],
      dimension: DimensionType.adv,
    })
    this.skipPage()
  }
  skipPage() {
    if (this.$route.query?.from === 'budget') {
      this.$router.push({ name: 'budget', query: { from: 'billing' } })
    } else {
      this.$router.replace({ name: 'objective' })
    }
  }
  /**
   * 由于advertiser/info接口有1s左右的缓存处理，如果连续发起【提交资质+调用advertiser/info】两个动作，获取用户状态不是最新依然是10（待补全资质）
   * 更新用户信息用于newSelf判断、dashboard banner展示、payment入口披露依赖最新数据
   */
  getRealTimeAccountStatus() {
    return this.loadAccountInfo({ aadvid: this.adverId, force: true })
  }
}
